import React from 'react'
import { Ordering } from 'storfox-filter'

import { MOVEMENT_COLUMNS as tableColumns } from './MovementList'

import { FILTER_NAME as name } from '../../constants'

export const movementOrderingOptions = {
  name,
  tableColumns
}

function MovementOrderingForm (props) {
  return (
    <Ordering {...props} />
  )
}

export default MovementOrderingForm
